import { HELP_URL } from '../config/addinNamespace';

/** The ERPs the portal's default-formula reference covers, by its URL slug. */
const SLUGS: Readonly<Record<string, string>> = {
  TRIPLETEX: 'tripletex',
  BUSINESS_CENTRAL: 'business-central',
  DYNAMICS_365: 'dynamics-365',
};

/**
 * The default formulas the reference documents. A formula outside this list
 * simply gets no link; one inside it that a company has edited still links,
 * and the page says that an edited formula may differ.
 */
const DOCUMENTED = /^(BALANCE|NETCHANGE|A[RP]_(BALANCE|SUMMARY|OPEN|AGING|TRANSACTIONS))$/;

/** Where the portal documents this default formula, or null for one it does not. */
export function formulaReferenceUrl(formula: { name: string; erpType?: string | null }): string | null {
  const slug = formula.erpType ? SLUGS[formula.erpType] : undefined;
  if (!slug || !DOCUMENTED.test(formula.name)) return null;
  return `${HELP_URL}/functions/${slug}#${formula.name}`;
}

/** Opens the reference outside the pane; the click is a user gesture, so window.open is allowed on the web. */
export function openFormulaReference(url: string): void {
  if (Office.context.ui?.openBrowserWindow) {
    Office.context.ui.openBrowserWindow(url);
    return;
  }
  window.open(url, '_blank', 'noopener');
}
